import dashboardApi from '@/services/dashboard';
import { Button, Dropdown, Icon, Menu } from 'antd';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
const Root = styled(Dropdown) `
  .add-workflow-modal {
    height: 680px;
  }
`;
const AddButton = ({ className, style }) => {
    const [flowDefList, setFlowDefList] = useState([]);
    useEffect(() => {
        dashboardApi
            .fetchFlowList()
            .promise.then((res) => setFlowDefList(res));
    }, []);
    const onMenuClick = (param) => {
        // createModal({
        //   hiddenFoot: true,
        //   className: 'add-workflow-modal',
        //   title: param.item.props.children,
        //   width: 720,
        //   content: <AddFlowModal id={param.key} />,
        // });
        window.open(`${process.env.MUJI_APP_URL_WORKBENCH}${param.key}`);
    };
    const menu = useMemo(() => {
        const flowMenuList = _.reduce(flowDefList, (values, v, k) => {
            if (values[v.flowType || '其它']) {
                values[v.flowType || '其它'].push(v);
            }
            else {
                values[v.flowType || '其它'] = [];
                values[v.flowType || '其它'].push(v);
            }
            return values;
        }, {});
        return (<Menu onClick={onMenuClick}>
        {Object.keys(flowMenuList).map(f => {
            return (<Menu.SubMenu title={f} key={f}>
              {flowMenuList[f]
                .filter(g => g.visible)
                .map(h => (<Menu.Item key={h.id}>{h.name}</Menu.Item>))}
            </Menu.SubMenu>);
        })}
      </Menu>);
    }, [flowDefList]);
    return (<Root overlay={menu} className={className}>
      <Button type="primary">
        <span>新建工单</span>
        <Icon type="down"/>
      </Button>
    </Root>);
};
export default AddButton;
